import React from 'react'

function LogoutSvg() {
  return (
    <>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          opacity='0.4'
          d='M9 7.2L9 16.8C9 20 11 22 14.2 22L16.79 22C20 22 22 20 22 16.8L22 7.21C22 4.01 20 2.01 16.8 2.01L14.2 2.01C11 2 9 4 9 7.2Z'
          fill='#6A80A3'
        />
        <path
          d='M5.57043 8.12016L2.22043 11.4702C1.93043 11.7602 1.93043 12.2402 2.22043 12.5302L5.57043 15.8802C5.86043 16.1702 6.34043 16.1702 6.63043 15.8802C6.92043 15.5902 6.92043 15.1102 6.63043 14.8202L4.56043 12.7502L15.2504 12.7502C15.6604 12.7502 16.0004 12.4102 16.0004 12.0002C16.0004 11.5902 15.6604 11.2502 15.2504 11.2502L4.56043 11.2502L6.63043 9.18016C6.78043 9.03016 6.85043 8.84016 6.85043 8.65016C6.85043 8.46016 6.78043 8.27016 6.63043 8.12016C6.34043 7.82016 5.87043 7.82016 5.57043 8.12016Z'
          fill='#6A80A3'
        />
      </svg>
    </>
  )
}

export default LogoutSvg
